<template>
	<v-dialog v-model="dialog" persistent max-width="400px">
		<v-card>
			<v-form>
				<v-toolbar dense card dark color="info">
					<v-toolbar-title>{{ title }}</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>
				<v-card-text>
					<v-select v-model="selectedVal" :items="items" return-object></v-select>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @click="onCancelClick">Cancel</v-btn>
					<v-btn color="primary" flat @click="onSaveClick">Save</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			title: {
				required: true,
				type: String
			},
			items: {
				required: true,
				type: Array
			},
			defaultSelectedVal: {
				required: false
			},
			dialog: {
				required: true,
				type: Boolean
			}
		},
		created() {
			if (this.defaultSelectedVal == null) {
				this.selectedVal = this.items[0];
			}

			this.selectedVal = this.defaultSelectedVal;
		},
		data() {
			return {
				selectedVal: null
			};
		},
		methods: {
			onCancelClick() {
				this.$emit('onClose');
			},
			onSaveClick() {
				this.$emit('onSave', this.selectedVal);
			}
		}
	};
</script>

<style></style>
